export const getRichTextContent = (text?: string): string => {
  if (!text) return '';
  return text
    .replace(/<br\s*\/?>/gi, '')
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/g, ' ')
    .trim();
};

export const isRichTextEmpty = (text?: string): boolean => {
  return getRichTextContent(text) === '';
};
